// @flow

import { Dispatcher } from 'flux';
import deprecated from '../decorators/deprecated';
import PayloadSources from './PayloadSources';

/**
 * The dispatcher is the core of the app
 * it’s the central hub for the messages (actions)
 * Two main methods, one will handle the dispatch of server-initiated action,
 * the other one the view-initiated actions.
 */
class AppDispatcher extends Dispatcher {

  /**
   * A bridge function between the actions create by an Api call and the dispatcher, marking
   * the action as a view action.
   * @param  {object} action The data coming from the API.
   */
  handleServerAction(action: Object) {
    // TODO: remove payload in favor of just dispatch the action.
    const payload = {
      source: PayloadSources.SERVER_ACTION,
      action
    };

    if (this.isDispatching()) {
      console.error(`[ACTION] ${action.type}`, 'is dispatching could not dispatch', action);
      // TODO: find another fix.
      setTimeout(() => {
        console.log('retry in 100 milliseconds');
        this.handleServerAction(action);
      }, 100);
    } else {
      console.info(`[ACTION] ${action.type}`, action);
      this.dispatch(payload);
    }
  }

  @deprecated
  handleViewAction(action: Object) {
    this.handleServerAction(action);
  }

}

export default new AppDispatcher();
